import { get } from '../../Common/utils';

import { dropDownDefault } from './constants';

const normalizeAggregators = (aggregators = []) =>
  dropDownDefault.concat(
    aggregators.map(aggregator => ({
      label: get(aggregator, 'aggregatorID', ''),
      value: get(aggregator, 'aggregatorID', ''),
    })),
  );

const normalizePayers = (payers = []) =>
  dropDownDefault.concat(
    payers.map(payer => {
      const id = get(payer, 'payerID', '');

      return {
        label: id ? `${get(payer, 'payerName', '')} (${id})` : '',
        value: id,
      };
    }),
  );

const normalizeResolutions = (resolutions = []) =>
  resolutions.map(resolution => ({
    resolutionCode: get(resolution, 'resolutionCode', ''),
    description: get(resolution, 'description', ''),
    alertType: get(resolution, 'alertType', ''),
  }));

export { normalizeAggregators, normalizePayers, normalizeResolutions };
